/* eslint-disable no-unused-vars */
import React, { useEffect } from 'react';
import { useAppSelector, useAppDispatch } from 'store/hooks';
import SuccessModal from 'components/modal/successModal';
import ErrorModal from 'components/modal/errorModal';
import { RootState } from 'store/store';
import { ActionCreatorWithoutPayload } from '@reduxjs/toolkit';
import { Result } from 'store/types';
import { useNavigate } from 'react-router-dom';

export const useModalResult = ({
  setCurrentModal,
  dropResult,
  selectResult,
}: {
  setCurrentModal: (a: null | React.ReactElement) => void;
  dropResult: ActionCreatorWithoutPayload<string>;
  selectResult: (state: RootState) => Result;
}) => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const result = useAppSelector(selectResult);

  useEffect(() => {
    if (result !== null) {
      if (result.type === 'error') {
        setCurrentModal(
          <ErrorModal
            onClose={() => {
              setCurrentModal(null);
            }}
            errorText={result.message}
          ></ErrorModal>
        );
      } else {
        setCurrentModal(
          <SuccessModal
            onClose={() => {
              setCurrentModal(null);

              if (result.redirect) {
                navigate(result.redirect, {
                  replace: false,
                });
              }
            }}
            successText={result.message}
          ></SuccessModal>
        );
      }

      dispatch(dropResult());
    }
  }, [result]);

  return null;
};
